exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-virtual-repeat-container.md-autocomplete-suggestions-container {\n  height: 420px;\n  max-height: 420px !important; }\n\n.force-return-button {\n  background-color: green;\n  transition: background-color 0.3s, box-shadow 0.5s; }\n\n.force-return-button:hover {\n  background-color: #015501;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/gas/gasArticles/gasarticles.component.scss
// module id = ../../../../../src/app/gas/gasArticles/gasarticles.component.scss
// module chunks = 0